import { render, staticRenderFns } from "./contador.vue?vue&type=template&id=0e559e32"
import script from "./contador.vue?vue&type=script&lang=js"
export * from "./contador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports